import BackSection from '../Services/BackSection';
import css from './style.module.css'

export default function NoTasksDisplay() {
    return (
        <div className={css.noTasksContainer}>
            <div className={css.noTasksIcon}>📋</div>
            <h3 className={css.noTasksTitle}>No Assignments Yet</h3>
            <p className={css.noTasksMessage}>
                You don't have any assignments at the moment.
            </p>
            <p className={css.noTasksSubtext}>
                Check back later for new tasks.
            </p>
        </div>
    );
}

export function NoDetailsDisplay() {
    return (
        <div>
            <BackSection pageName="Assignments" to={"/assignments"} />
            <div className={css.errorContainer}>
                <div className={css.errorIcon}>📋</div>
                <h2 className={css.errorTitle}>Assignment Not Found</h2>
                <p className={css.errorMessage}>
                    The assignment you're looking for doesn't exist or has been deleted.
                </p>
                <button
                    onClick={() => window.location.href = '/assignments'}
                    className={css.primaryButton}
                >
                    Back to Assignments
                </button>
            </div>
        </div>
    );
}
